<template>
    <button 
        class="btn" 
        :class="'btn-' + ( color ? color : 'success' ) + ( sizing == 'sm' ? ' btn-sm' : '' )"
        type="button"
        @click="$emit('click')" 
        :disabled="disabled || $store.state.loading">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
            :class="hide_content_while_loading ? 'mr-0' : 'mr-2'"
            v-if="$store.state.loading && !nospinner"></span>
        <slot v-if="!hide_content_while_loading || !$store.state.loading"></slot>
    </button>
</template>

<script>
export default {
    props: ['color', 'disabled', 'sizing', 'hide_content_while_loading', 'type', 'nospinner']
}
</script>